import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  addSubsystemInlay: {
    margin: '10px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.light,
        borderWidth: 1,
      },
      '& .MuiOutlinedInput-input': {
        height: '16px',
        padding: '6px',
        fontSize: '14px',
      },
    },
  },
  plusIcon: {
    marginRight: 8,
    fontSize: 16,
    width: 14,
    height: 16,
    padding: 5,
    border: '1px solid',
    display: 'inline-flex',
    borderRadius: 4,
    cursor: 'pointer',
  },
}));

export default useStyles;
